import React, { useState, useEffect } from "react";
import CSVReader from "react-csv-reader";
import styled from "styled-components";
import CheckIcon from "../../Assets/upload-check.svg";
import CautionIcon from "../../Assets/Caution.svg";
import { withRouter } from "react-router";
import Select from "react-select";
// file
import ZipFile from "../../Assets/files/zipcode.csv";
import UsersQuestions from "../../Assets/files/questions.csv";
import { CSVLink } from "react-csv";
import axios from "axios";
import moment from "moment";
import ModalStyle from "./style";
import "rsuite/dist/rsuite.css";
import { DateRangePicker } from "rsuite";
import { defaultHeaders } from "../../Redux/Constants/DefaultHeaders";
const { afterToday } = DateRangePicker;
function Modal(props) {
  const [fileInfo, setFileInfo] = useState("");
  const [error, setError] = useState("");

  // Date Picker
  const [userType, setUserType] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startDateView, setStartDateView] = useState(null);
  const [endDateView, setEndDateView] = useState(null);
  const [apiStartDate, setApiStartDate] = useState(null);
  const [apiEndDate, setApiEndDate] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);
  const [sampleFile, setSampleFile] = useState();
  const [serviceData, setServiceData] = useState();

  var _date = moment();
  var _date2 = moment().date(0);

  const handleDatesChange = (dateData) => {
    if (dateData) {
      const startDate = dateData[0];
      const endDate = dateData[1];
      const newStartDate = moment(startDate).format("YYYY-MM-DD");
      setApiStartDate(newStartDate);
      const newEndDate = moment(endDate).format("YYYY-MM-DD");
      setApiEndDate(newEndDate);
      props.handleDate(newStartDate, newEndDate);
    }
  };

  const handleForce = (data, fileInfo) => {
    const extension = fileInfo.name.split(".").pop();
    if (extension.toLowerCase() === "csv" || fileInfo.type === "application/vnd.ms-excel") {
      setFileInfo(data);
      setError("");
    } else {
      setError("Some error occurred while importing");
    }
  };

  const handleError = (e) => {
    setError(e);
  };

  const colourStyles = {
    control: (styles, state) => ({
      ...styles,
      backgroundColor: "#3C3C3C",
      border: state.isFocused ? "1px solid #A0A0A0" : "1px solid #3C3C3C",
      transition: "all 0.25s linear 0s",
      "&:hover": {
        border: "1px solid #A0A0A0",
      },
      padding: "4px 6px",
      boxShadow: state.isFocused ? null : null,
    }),
    singleValue: (baseStyles, state) => ({
      ...baseStyles,
      color: state.isFocused ? "#ffffff" : "#ffffff",
      backgroundColor: "#3C3C3C",
    }),
  };

  const Overlay = styled.div`
    background: #000000;
    opacity: 0.5;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 10;
  `;

  const Container = styled.div`
    border-radius: 10px;
    padding: 45px;
    top: 20%;
    left: 50%;
    z-index: 12;
    transform: translate(-240px, -80px);
  `;

  const Content = styled.h2`
    font-size: 25px;
    width: 345px;
    word-break: break-word;
  `;

  const GhostButton = styled.button`
    padding: 7px 55px;
    border: 2px solid #bdff00;
    box-sizing: border-box;
    border-radius: 24px;
    background: transparent;
    font-weight: 700;
  `;

  const Button = styled.button`
    padding: 7px 55px;
    border: 2px solid #bdff00;
    box-sizing: border-box;
    border-radius: 24px;
    background: #bdff00;
    font-weight: 700;
  `;

  const ZipCode = styled.p`
    color: #6fcf97;
    font-size: 24px;
  `;

  const ZipCodeError = styled.p`
    color: #ff3b30;
    font-size: 24px;
  `;

  const _pullSampleCsv = async (user, start, end) => {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}api/admin/export_user_template`, {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
    });
    if (res.status === 200) {
      setSampleFile(res.data.data);
    } else {
    }
  };

  useEffect(() => {
    _pullSampleCsv();
  }, []);

  const handleUserType = (e) => {
    setServiceData();
    setUserType(e);

    if (e.id !== "" && apiStartDate && apiEndDate) {
      DownloadCSV(e.id, apiStartDate, apiEndDate);
    }
  };

  const DownloadCSV = async (user, start, end) => {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}api/admin/download_service_requests?date=${start},${end}&user_type=${user}`, {
      headers: defaultHeaders(),
    });
    if (res.status === 200) {
      setServiceData(res.data.data);
    } else {
    }
  };

  const UserTypeOptions = [
    { value: "All", label: "All", id: "2,3" },
    { value: "Personal Banking", label: "Personal Banking", id: "2" },
    { value: "Business", label: "Business", id: "3" },
    { value: "Vibe User", label: "Vibe User", id: "5" },
  ];

  return (
    <>
      <Overlay className="position-fixed" />
      <Container className="position-fixed dark-background" style={props.Type === "excel-upload" ? { width: "480px" } : { width: "" }}>
        <ModalStyle />
        {props.Type !== "excel-upload" && (
          <>
            {props.Type === "copy_bank" && (
              <div className="justify-content-center mt-5">
                <div>
                  <Content className="text-white text-center m-auto">Are you sure you want to create this copy?</Content>
                </div>
                <br />
                <br />
                <GhostButton onClick={(e) => props.Close(e, "copy_bank_no")} className="f-14 text-green mr-2">
                  No
                </GhostButton>
                <Button onClick={(e) => props.Close(e, "copy_bank_yes")} className="f-14 green-background ml-2">
                  Yes
                </Button>
              </div>
            )}
            {props.Type === "add" && <Content className="text-white text-center m-auto">Are you sure you want to add this detail?</Content>}
            {props.Type === "delete" && <Content className="text-white text-center m-auto">Are you sure you want to delete this detail?</Content>}
            {props.Type === "update" && <Content className="text-white text-center m-auto">Are you sure to update info for {props.Name}?</Content>}
            {props.Type === "remove_business" && (
              <div className="text-white text-center m-auto" style={{ maxWidth: "400px" }}>
                <h3 className="text-center">WARNING</h3>
                <p className="text-center">Removing Business users from this service will also remove all of their sub-admins from this service. Their sub-admins will not regain access to this service until the Business user grants them permission again.</p>
              </div>
            )}
            {props.Type === "enable" && <Content className="text-white text-center m-auto">{`Are you sure you want to disable ${props.Name}?`.replace(/\u2028/g, " ")}</Content>}
            {props.Type === "disable" && <Content className="text-white text-center m-auto">{`Are you sure you want to enable ${props.Name}?`.replace(/\u2028/g, " ")}</Content>}
            {props.Type === "logout" && <Content className="text-white text-center m-auto">Are you sure you wish to logout?</Content>}
            {props.Type === "update_password" && <Content className="text-white text-center m-auto">Are you sure you wish to update password?</Content>}
            {props.Type === "update_password" && (
              <div className="d-flex justify-content-center mt-5">
                <GhostButton onClick={(e) => props.Close(e, "update_password_no")} className="f-14 text-green mr-2">
                  No
                </GhostButton>
                <Button onClick={(e) => props.Close(e, "update_password_yes")} className="f-14 green-background ml-2">
                  Yes
                </Button>
              </div>
            )}
            {props.Type === "logout" && (
              <div className="d-flex justify-content-center mt-5">
                <GhostButton onClick={(e) => props.Close(e, "logout_no")} className="f-14 text-green mr-2">
                  No
                </GhostButton>
                <Button onClick={(e) => props.Close(e, "logout_yes")} className="f-14 green-background ml-2">
                  Yes
                </Button>
              </div>
            )}
            {props.Type === "delete" && (
              <div className="d-flex justify-content-center mt-5">
                <GhostButton onClick={(e) => props.Close(e, "delete_no")} className="f-14 text-green mr-2">
                  No
                </GhostButton>
                <Button onClick={(e) => props.Close(e, "delete_yes")} className="f-14 green-background ml-2">
                  Yes
                </Button>
              </div>
            )}
            {props.Type === "update" && (
              <div className="d-flex justify-content-center mt-5">
                <GhostButton onClick={(e) => props.Close(e, "update_no")} className="f-14 text-green mr-2">
                  No
                </GhostButton>
                <Button onClick={(e) => props.Close(e, "update_yes")} className="f-14 green-background ml-2">
                  Yes
                </Button>
              </div>
            )}
            {props.Type === "remove_business" && (
              <div className="d-flex justify-content-center mt-5">
                <GhostButton onClick={(e) => props.Close(e, "dont_remove_business_user_type")} className="f-14 text-green mr-2">
                  No
                </GhostButton>
                <Button onClick={(e) => props.Close(e, "remove_business_user_type")} className="f-14 green-background ml-2">
                  Yes
                </Button>
              </div>
            )}
            {props.Type === "add" && (
              <div className="d-flex justify-content-center mt-5">
                <GhostButton onClick={(e) => props.Close(e, "add_no")} className="f-14 text-green mr-2">
                  No
                </GhostButton>
                <Button onClick={(e) => props.Close(e, "add_yes")} className="f-14 green-background ml-2">
                  Yes
                </Button>
              </div>
            )}
            {props.Type === "disable" && (
              <div className="d-flex justify-content-center mt-5">
                <GhostButton onClick={(e) => props.Close(e, "disable_no")} className="f-14 text-green mr-2">
                  No
                </GhostButton>
                <Button onClick={(e) => props.Close(e, "disable_yes")} className="f-14 green-background ml-2">
                  Yes
                </Button>
              </div>
            )}
            {props.Type === "enable" && (
              <div className="d-flex justify-content-center mt-5">
                <GhostButton onClick={(e) => props.Close(e, "enable_no")} className="f-14 text-green mr-2">
                  No
                </GhostButton>
                <Button onClick={(e) => props.Close(e, "enable_yes")} className="f-14 green-background ml-2">
                  Yes
                </Button>
              </div>
            )}
          </>
        )}
        {props.Type === "excel-export" && (
          <>
            <div>
              <div className="w-100">
                <label htmlFor="title" className="text-grey-6 f-16 d-block mb-1">
                  Date <span className="text-danger">*</span>
                </label>

                <DateRangePicker
                  showOneCalendar
                  disabledDate={afterToday()}
                  appearance={"subtle"}
                  format={"MM/dd/yyyy"}
                  // defaultCalendarValue={[new Date(_date2), new Date(_date)]}
                  value={startDate ? startDate : ""}
                  className="w-100 input-style"
                  placeholder={"Select Date"}
                  onChange={(e) => {
                    setStartDate(e);
                    handleDatesChange(e);
                  }}
                />

                <div className="w-100 mt-4">
                  <label htmlFor="errorText" className="text-grey-6 f-16 d-block mb-1">
                    User Type <span className="text-danger">*</span>
                  </label>
                  <Select onChange={(e) => handleUserType(e, "input_type")} options={UserTypeOptions} styles={colourStyles} placeholder="Select Type" value={userType} />
                </div>
              </div>
              <div className="d-flex justify-content-center mt-5">
                <GhostButton onClick={(e) => props.Close(e, "enable_no")} className="f-14 text-green mr-2">
                  Cancel
                </GhostButton>
                {serviceData ? (
                  <Button>
                    {" "}
                    <CSVLink filename={"service-request.csv"} data={serviceData ? serviceData : ""} className="download-btn-service">
                      Download
                    </CSVLink>{" "}
                  </Button>
                ) : (
                  <Button
                    //onClick={(e) => DownloadCSV()}
                    disabled={!serviceData}
                    className=""
                  >
                    Download
                  </Button>
                )}
              </div>
            </div>
          </>
        )}

        {props.Type === "Camera-Modal" && (
          <>
            <p className={"closeCamera"} onClick={(e) => props.CloseModal(e, "enable_no")}>
              <button>
                <span>&times;</span>
              </button>
            </p>
            <img width={320} src={props.cameraUrl} alt="image" />
          </>
        )}

        {props.Type === "excel-upload" && (
          <>
            {error === "" && fileInfo === "" ? (
              <>
                <label className="custom-file-upload position-relative d-flex align-items-center justify-content-center mb-0 w-100">
                  <CSVReader
                    cssClass="d-none"
                    onFileLoaded={handleForce}
                    onError={handleError}
                    parserOptions={{
                      header: true,
                      dynamicTyping: true,
                      skipEmptyLines: true,
                    }}
                  />
                  <span>Click to browses</span>
                </label>
                <div className="text-center mt-5">
                  <GhostButton onClick={(e) => props.Close(e)} className="f-14 text-green">
                    Cancel
                  </GhostButton>
                </div>
                {props.location.pathname === "/dashboard/users" && sampleFile && (
                  <p className="text-white text-center mt-4 mb-0">
                    <CSVLink filename={"User-upload.csv"} data={sampleFile} className="text-green download-btn">
                      Click Here
                    </CSVLink>{" "}
                    to Download sample
                  </p>
                )}
                {props.location.pathname === "/dashboard/zipcodes" && (
                  <p className="text-white text-center mt-4 mb-0">
                    <a download={ZipFile} href={ZipFile} className="text-green">
                      Click Here{" "}
                    </a>
                    to Download sample
                  </p>
                )}
                {props.location.pathname === "/dashboard/questions" && (
                  <p className="text-white text-center mt-4 mb-0">
                    <a download={UsersQuestions} href={UsersQuestions} className="text-green">
                      Click Here{" "}
                    </a>
                    to Download sample
                  </p>
                )}
              </>
            ) : (
              <>
                {error === "" && (
                  <div className="text-center">
                    <img src={CheckIcon} alt="CheckIcon" />
                    {props.location.pathname === "/dashboard/users" && <ZipCode className="mt-4">{fileInfo.length} records are selected for processing.</ZipCode>}
                    {props.location.pathname === "/dashboard/zipcodes" && <ZipCode className="mt-4">{fileInfo.length} records are selected for processing.</ZipCode>}
                    {props.location.pathname === "/dashboard/questions" && <ZipCode className="mt-4">{fileInfo.length} records are selected for processing.</ZipCode>}
                  </div>
                )}
                {error === "" && (
                  <div className="text-center mt-5">
                    <GhostButton onClick={(e) => props.Close(e)} className="f-14 text-green mr-2">
                      No
                    </GhostButton>
                    <Button
                      onClick={(e) => {
                        props.Upload(e, fileInfo);
                        props.Close(e);
                      }}
                      className="f-14 green-background ml-2"
                    >
                      Okay
                    </Button>
                  </div>
                )}
              </>
            )}
            {error !== "" && (
              <>
                <div className="text-center">
                  <img src={CautionIcon} alt="CheckIcon" />
                  <ZipCodeError className="mt-4">{error}</ZipCodeError>
                </div>
                <div className="text-center mt-5">
                  <GhostButton onClick={(e) => props.Close(e)} className="f-14 text-green">
                    No
                  </GhostButton>
                  <Button
                    onClick={() => {
                      setError("");
                    }}
                    className="f-14 green-background ml-3"
                  >
                    Retry
                  </Button>
                </div>
              </>
            )}
          </>
        )}
      </Container>
    </>
  );
}

export default withRouter(Modal);
